import client from '@/api/client'
import applepayExpressQuery from '@/api/gql/checkout/query/applepay-express.gql'
import applepayExpressRequestQuery from '@/api/gql/checkout/query/applepay-express-request.gql'
import resetCurrentOrderMutation from '@/api/gql/checkout/mutation/reset-current-order.gql'

class ApiService {
  constructor(options = {}) {
    const { http, paths } = options
    this.http = http
    this.paths = paths
  }

  fetchApplePayExpressCheckout() {
    return client.query({ query: applepayExpressQuery }).then(({ data }) => data)
  }

  fetchApplePayExpressCheckoutRequest() {
    return client
      .query({ query: applepayExpressRequestQuery })
      .then(({ data: { checkout } }) => checkout.applePay.expressCheckoutRequest)
  }

  authorizeMerchant(validationURL) {
    return this.http.post(this.paths.authorizeMerchantsUrl, {
      url: validationURL,
    })
  }

  authorizePayment(paymentData) {
    return this.http.post(this.paths.applePayAuthorizePaymentUrl, paymentData)
  }

  updateCheckoutAddress(attrs) {
    return this.http.patch(this.paths.updateCheckoutAdressUrl, attrs)
  }

  updateCheckoutDelivery(attrs) {
    return this.http.patch(this.paths.updateCheckoutDeliveryUrl, attrs)
  }

  updateCheckoutRegistration(attrs) {
    return this.http.put(this.paths.updateCheckoutRegistrationUrl, attrs)
  }

  resetCurrentOrder() {
    return client
      .mutate({
        mutation: resetCurrentOrderMutation,
      })
      .then(({ data }) => data)
  }
}

export default ApiService
